import { useTheme } from '../context/ThemeContext';
import { MEASUREMENT_LABELS, getUnit } from '../utils/dynamics';

const ROWS = [
  'weight_kg','chest_cm','bicep_cm','waist_cm',
  'abdomen_cm','hips_cm','thigh_cm','above_knee_cm','calf_cm',
];

export default function MeasurementTable({ measurements, onEdit }) {
  const { isDark, theme } = useTheme();
  if (!measurements?.length) return null;

  const sorted = [...measurements].sort((a,b) => new Date(b.measured_at) - new Date(a.measured_at));
  const cols   = sorted.slice(0, 6); // последние 6 замеров
  const acc    = theme.accent;

  const card = isDark ? '#1A1526' : '#FFFFFF';
  const bdr  = isDark ? 'rgba(255,255,255,.07)' : 'rgba(0,0,0,.06)';
  const txt  = isDark ? '#F2EEF9' : '#2D1B35';
  const mut  = isDark ? 'rgba(200,185,220,.5)' : 'rgba(80,60,100,.5)';
  const hdr  = isDark ? '#13101E' : '#F5F0FF';
  const row1 = isDark ? 'rgba(255,255,255,.02)' : 'rgba(0,0,0,.018)';

  const first = sorted[sorted.length - 1];

  const getDelta = (field, colIdx) => {
    const cur  = parseFloat(cols[colIdx]?.[field]);
    const base = parseFloat(first?.[field]);
    if (!cur || !base || isNaN(cur) || isNaN(base)) return null;
    return Math.round((cur - base) * 10) / 10;
  };

  return (
    <div style={{ borderRadius:16, overflow:'hidden', border:`1px solid ${bdr}`,
                  boxShadow:isDark?'0 2px 12px rgba(0,0,0,.3)':'0 2px 16px rgba(100,60,140,.08)' }}>
      <div style={{ overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:460 }}>
          <thead>
            <tr style={{ background:hdr }}>
              <th style={{ padding:'12px 16px', textAlign:'left', color:mut,
                           fontSize:'.7rem', fontWeight:700, textTransform:'uppercase',
                           letterSpacing:'.08em', borderBottom:`1px solid ${bdr}`,
                           position:'sticky', left:0, background:hdr, zIndex:1 }}>
                Показатель
              </th>
              {cols.map((m, i) => (
                <th key={m.id} style={{ padding:'12px 14px', textAlign:'center',
                                        borderBottom:`1px solid ${bdr}`,
                                        borderLeft:`1px solid ${bdr}`,
                                        minWidth:90 }}>
                  <div style={{ color:i===0?acc:txt, fontSize:'.78rem', fontWeight:i===0?700:500 }}>
                    {new Date(m.measured_at).toLocaleDateString('ru-RU',{day:'numeric',month:'short'})}
                  </div>
                  {i===0 && <div style={{ color:acc, fontSize:'.6rem', fontWeight:600, marginTop:2 }}>Последний</div>}
                  {onEdit && (
                    <button onClick={() => onEdit(m)} style={{
                      marginTop:4, background:'none', border:`1px solid ${bdr}`,
                      borderRadius:6, padding:'2px 7px', fontSize:'.65rem',
                      color:mut, cursor:'pointer', display:'block', margin:'4px auto 0',
                    }}>✏️ ред.</button>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((field, ri) => {
              const hasAny = cols.some(m => m[field] != null && m[field] !== '');
              if (!hasAny) return null;
              return (
                <tr key={field} style={{ background: ri%2===0 ? 'transparent' : row1 }}>
                  <td style={{
                    padding:'11px 16px', color:txt, fontSize:'.82rem', fontWeight:500,
                    borderBottom:`1px solid ${bdr}`, position:'sticky', left:0,
                    background: ri%2===0 ? card : (isDark?'rgba(26,21,37,1)':'rgba(248,245,255,1)'),
                    zIndex:1, whiteSpace:'nowrap',
                  }}>
                    {MEASUREMENT_LABELS[field]}
                    <span style={{ color:mut, fontSize:'.7rem', marginLeft:4 }}>({getUnit(field)})</span>
                  </td>
                  {cols.map((m, ci) => {
                    const val   = m[field] != null ? parseFloat(m[field]) : null;
                    const delta = getDelta(field, ci);
                    const COLOR_FIELDS = ['weight_kg', 'waist_cm', 'abdomen_cm'];
                    const useColor = COLOR_FIELDS.includes(field);
                    const dColor = !useColor || delta === null || delta === 0
                      ? txt
                      : (delta < 0 ? '#22C55E' : '#EF4444');

                    return (
                      <td key={m.id} style={{
                        padding:'11px 14px', textAlign:'center',
                        borderBottom:`1px solid ${bdr}`, borderLeft:`1px solid ${bdr}`,
                      }}>
                        {val != null ? (
                          <>
                            <div style={{ color: txt, fontFamily:'Nunito,system-ui',
                                          fontWeight: ci===0 ? 700 : 400, fontSize:'.9rem' }}>
                              {val}
                            </div>
                            {ci===0 && delta !== null && (
                              <div style={{ color:dColor, fontSize:'.68rem', fontWeight:600, marginTop:2 }}>
                                {delta>0?'+':''}{delta}
                              </div>
                            )}
                          </>
                        ) : (
                          <span style={{ color:txt, fontSize:'.75rem' }}>—</span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {measurements.length > 6 && (
        <div style={{ padding:'8px 16px', background:hdr, borderTop:`1px solid ${bdr}`,
                      color:mut, fontSize:'.72rem', textAlign:'center' }}>
          Показаны последние 6 замеров из {measurements.length}
        </div>
      )}
    </div>
  );
}
